export const Activity = (props: any) => {
  return (
    <svg width="32" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1882_8472)">
      <path d="M24 16C24 15.24 24.43 14.58 25.06 14.24C25.66 13.91 26 13.23 26 12.54V10C26 8.9 25.1 8 24 8H8C6.9 8 6.01 8.89 6.01 9.99V12.54C6.01 13.23 6.34 13.91 6.95 14.23C7.58 14.58 8 15.24 8 16C8 16.76 7.57 17.43 6.94 17.76C6.34 18.09 6 18.77 6 19.46V22C6 23.1 6.9 24 8 24H24C25.1 24 26 23.1 26 22V19.46C26 18.77 25.66 18.09 25.06 17.76C24.43 17.42 24 16.76 24 16ZM18.5 20.1L16 18.5L13.5 20.11C13.12 20.35 12.63 20 12.75 19.56L13.5 16.68L11.2 14.8C10.85 14.51 11.03 13.94 11.49 13.91L14.45 13.74L15.53 10.99C15.7 10.57 16.3 10.57 16.46 10.99L17.54 13.75L20.5 13.92C20.95 13.95 21.14 14.52 20.79 14.81L18.49 16.69L19.25 19.55C19.37 20 18.88 20.35 18.5 20.1Z" fill={props.fill ?? "#011BB6"} />
      </g>
      <defs>
        <clipPath id="clip0_1882_8472">
        <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}